var render, staticRenderFns
import script from "./OptionGroup.vue?vue&type=script&lang=js&"
export * from "./OptionGroup.vue?vue&type=script&lang=js&"
import style0 from "veui-theme-dls/components/option-group.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports